export enum TipoCartao {
	DEBITO = <any>'debito',
	CARTAO = <any>'cartao',
	CREDITO = <any>'credito',
	BOLETO = <any>'boleto'
}
